 
import { downloadFile } from "../Files/svg_icons";

function Intro (props) {



    const {myIntro, resume_file, section_headings} = props;
    return (
        <>
            <section className="intro" id="intro">
                <h1 className="section-heading myname">Vedanshu Malik</h1>
                <strong className="mytitle">{`${myIntro[0]}`}</strong>
                <p className="summary">
                    {myIntro[1]}
                </p>

                <p className="summary2">
                    {myIntro[2]}
                </p>

                <a
                    href={`https://vedanshu.de/resume/${resume_file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="resume-download-icon"
                >
                    {section_headings.download_resume} <img src={downloadFile} alt="resume" />
                </a>
                
            </section>
        </>
    );
}

export default Intro;